import React from 'react';

/**
 * HeaderGlow - A thin elegant glowing separator line
 */
const HeaderGlow = ({ className = '' }) => {
  return (
    <div className={`w-full h-3 relative ${className}`}>
      {/* Slightly wider glow line */}
      <div 
        className="absolute inset-x-0 top-0 h-[2px]"
        style={{
          background: 'rgba(255, 255, 255, 0.5)',
          boxShadow: '0 0 6px 2px rgba(255, 255, 255, 0.35)',
        }}
      />
    </div>
  );
};

export default HeaderGlow;
